import { atom } from 'jotai';
import { loadable } from 'jotai/utils';
import { fetchUnreadCount } from '../api/notifications';

// Async atom that fetches unread count
const unreadCountFetchAtom = atom(async () => {
    return await fetchUnreadCount();
});

const unreadCountLoadableAtom = loadable(unreadCountFetchAtom);
const unreadCountOverrideAtom = atom(null);

// Self-loading, writable. Returns 0 while loading.
// Same pattern as packCountAtom.
export const unreadCountAtom = atom(
    (get) => {
        const override = get(unreadCountOverrideAtom);
        if (override !== null) return override;
        const fetched = get(unreadCountLoadableAtom);
        return fetched.state === 'hasData' ? fetched.data : 0;
    },
    (get, set, update) => {
        const override = get(unreadCountOverrideAtom);
        const fetched = get(unreadCountLoadableAtom);
        const current = override !== null
            ? override
            : fetched.state === 'hasData' ? fetched.data : 0;
        set(unreadCountOverrideAtom, typeof update === 'function' ? update(current) : update);
    }
);
